const Menu = [
  { header: "menu.headers.main" },
  {
    title: "menu.requests",
    icon: "pin_drop",
    name: "Requests",
    permission: "DISPATCHING",
  },
  {
    title: "menu.phoneBooking",
    icon: "call",
    name: "PhoneBooking",
    permission: "PHONE_BOOKING",
  },
  {
    title: "menu.tracking",
    icon: "gps_fixed",
    name: "CaptainsMap",
    permission: "MONITORING",
  },
  {
    title: "menu.complaints",
    icon: "report_problem",
    name: "ComplaintsList",
    permission: "COMPLAINTS",
  },
  {
    title: "menu.reservations",
    icon: "assignment",
    name: "ReservationsList",
    permission: "RESERVATIONS",
  },

  { header: "menu.headers.maps" },
  {
    title: "menu.maps",
    icon: "map",
    items: [
      {
        name: "Locations",
        icon: "place",
        title: "menu.sectors",
        permission: "LOCATIONS",
      },
      {
        name: "stations",
        icon: "directions_bus",
        title: "menu.stations",
        permission: "LOCATIONS",
      },
      {
        name: "Landmarks",
        icon: "flag",
        title: "menu.landmarks",
        permission: "LANDMARK_MANAGEMENT",
      },
      {
        title: "menu.mapEditor",
        icon: "edit_location_alt",
        name: "MapEditor",
        permission: "EDIT_MAP",
      },
      {
        title: "menu.destinationEditor",
        icon: "edit_road",
        name: "EditSeasonalDestinations",
        permission: "EDIT_DESTINATION_SEASONAL",
      },
      {
        title: "menu.monacoEditor",
        icon: "code",
        name: "MonacoEditor",
        permission: "EDIT_MAP",
      },
      {
        title: "menu.restrictedAreas",
        icon: "no_encryption",
        name: "RestrictedAreas",
        permission: "RESTRICTED_AREA",
      },
      {
        title: "menu.dispatchingPolygon",
        icon: "share_location",
        name: "DispachingPolygon",
        permission: "RESTRICTED_AREA",
      },
    ],
  },

  { header: "menu.headers.fleet" },
  {
    title: "menu.drivers",
    icon: "drive_eta",
    name: "Captains",
    permission: "REGISTERED_CAPTAINS",
  },
  {
    title: "menu.fleet",
    icon: "local_taxi",
    items: [
      {
        title: "menu.carBrands",
        icon: "category",
        name: "CarBrands",
        permission: "TYPES",
      },
      {
        title: "menu.carColors",
        icon: "palette",
        name: "Colors",
        permission: "TYPES",
      },
      {
        title: "menu.vehicleTypes",
        icon: "directions_car",
        name: "VehicleTypesManagement",
        permission: "VEHICLE_TYPE_MANAGEMENT",
      },
      {
        title: "menu.constraints",
        icon: "rule",
        name: "Constraints",
        permission: "CONSTRAINTS",
      },
    ],
  },

  { header: "menu.headers.people" },
  {
    title: "menu.staff",
    icon: "badge",
    name: "Staff",
    permission: "USERS",
  },
  {
    title: "menu.passengers",
    icon: "person",
    name: "Passengers",
    permission: "PASSENGERS",
  },
  {
    title: "menu.customers",
    icon: "business",
    items: [
      {
        title: "menu.companies",
        icon: "apartment",
        name: "Companies",
        permission: "ACCOMMODATION",
      },
      {
        title: "menu.companyRequests",
        icon: "domain_add",
        name: "CompanyRequests",
        permission: "COMPANY_REQUESTS",
      },
      {
        title: "menu.hotels",
        icon: "hotel",
        name: "Hotels",
        permission: "ACCOMMODATION",
      },
      {
        title: "menu.hotelsUsers",
        icon: "manage_accounts",
        name: "HotelsUsers",
        permission: "ACCOMMODATION",
      },
      {
        title: "menu.restaurants",
        icon: "restaurant",
        name: "Restaurants",
        permission: "ACCOMMODATION",
      },
      {
        title: "menu.restaurantsUsers",
        icon: "supervisor_account",
        name: "RestaurantsUsers",
        permission: "ACCOMMODATION",
      },
    ],
  },

  { header: "menu.headers.reservations" },
  {
    title: "menu.reservationQueue",
    icon: "queue",
    name: "ReservationQueue",
    permission: "RESERVATION_QUEUE",
  },

  { header: "menu.headers.planning" },
  {
    title: "menu.shifts",
    icon: "event",
    name: "Shifts",
    permission: "PLANNING",
  },
  {
    title: "menu.shiftsMap",
    icon: "map",
    name: "ShiftsMap",
    permission: "PLANNING",
  },
  {
    title: "menu.specialEvents",
    icon: "celebration",
    name: "special_events",
    permission: "SPECIAL_EVENTS",
  },
  {
    title: "menu.eventsReports",
    icon: "assessment",
    name: "EventsReport",
    permission: "EVENTS_REPORTS",
  },

  { header: "menu.headers.communication" },
  {
    title: "menu.messages",
    icon: "chat",
    name: "Messages",
    permission: "MESSAGES",
  },
  {
    title: "menu.driversAnnouncements",
    icon: "campaign",
    name: "DriversAnnouncements",
    permission: "CAPTAINS",
  },
  {
    title: "menu.scheduledMessages",
    icon: "schedule_send",
    name: "scheduled_messages",
    permission: "SCHEDULED_MESSAGES",
  },
  {
    title: "menu.smsCodes",
    icon: "sms",
    name: "sms_codes",
    permission: "SMS_CODES",
  },
  {
    title: "menu.surveys",
    icon: "poll",
    name: "Surveys",
    permission: "SURVEYS",
  },
  {
    title: "menu.lostAndFound",
    icon: "shopping_basket",
    name: "lost_and_found",
    permission: "LOST_AND_FOUND",
  },

  { header: "menu.headers.finance" },
  {
    title: "menu.payments",
    icon: "payment",
    name: "payments",
    permission: "CARLO_PAYMENT",
  },
  {
    title: "menu.priceRules",
    icon: "attach_money",
    name: "PriceRules",
    permission: "PRICE_RULES",
  },

  { header: "menu.headers.reportsSettings" },
  {
    title: "menu.statistics",
    icon: "bar_chart",
    name: "BarStatistics",
    permission: "STATISTICS",
  },
  {
    title: "menu.authLogs",
    icon: "security",
    name: "AuthLogs",
    permission: "AUTHENTICATION_LOG",
  },
  {
    title: "menu.autoRegulation",
    icon: "block",
    name: "BlockedCaptains",
    permission: "AUTO_REGULATION",
  },
  {
    title: "menu.settings",
    icon: "tune",
    items: [
      {
        title: "menu.settings",
        icon: "settings",
        name: "Settings",
        permission: "SETTINGS",
      },
      {
        title: "menu.dispatching",
        icon: "alt_route",
        name: "Dispatching",
        permission: "DISPATCHING_CONFIG",
      },
      {
        title: "menu.termsAndConditions",
        icon: "gavel",
        name: "TermsAndConditions",
        permission: "T_C",
      },
      {
        title: "menu.maxBookingsCounts",
        icon: "format_list_numbered",
        name: "MaxBookingCount",
        permission: "T_C",
      },
      {
        title: "menu.vacations",
        icon: "beach_access",
        name: "Vacations",
        permission: "VACATIONS",
      },
    ],
  },
];

export default Menu;
